import { render, staticRenderFns } from "./remote-medical.vue?vue&type=template&id=38c2f489"
import script from "./remote-medical.vue?vue&type=script&lang=js"
export * from "./remote-medical.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports